module.exports = __webpack_public_path__ + "static/media/guangtoushan_web.25fb6df0.webp";